import { ca } from '@cian/analytics';
import { EPageType } from '../../types/pageType';

export const trackOnboardingButtonShow = (analyticsType: string[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Show_onboarding',
    page: {
      pageType: EPageType.Other,
      extra: {
        chat_id: 'chatbot',
        onboarding: analyticsType,
      },
    },
  });
};

export const trackOnboardingButtonClick = (analyticsType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_onboarding',
    label: analyticsType,
    page: {
      pageType: EPageType.Other,
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};
